import { CHANGE_TYPE } from "../../../api/v2/forms/exam_comparison";

export default class ChangeLog {
    constructor(readonly change: string, readonly before: any, readonly after: any){}
}


export class QuestionChangeLog extends ChangeLog {
    constructor(
        readonly type: CHANGE_TYPE, 
        readonly change: string, 
        readonly before: any, 
        readonly after: any){
        super(change, before, after)
    }
}

export class AnswerChangeLog extends ChangeLog {
    constructor(
        readonly type: CHANGE_TYPE, 
        readonly change: string, 
        readonly before: any, 
        readonly after: any){
        super(change, before, after)
    }
}

export class SkillChangeLog extends ChangeLog {
    constructor(
        readonly type: CHANGE_TYPE, 
        readonly change: string, 
        readonly before: any, 
        readonly after: any){
        super(change, before, after)
    }
}